'use-strict';

import angular from 'angular';

export class ModalOverlayService {
  constructor($http, $rootScope, usersApiService, $compile) {
    'ngInject';

    this.$http = $http;
    this.$rootScope = $rootScope;
    this.usersApiService = usersApiService;
    this.$compile = $compile;
  }

  /**
   * Show a fixed positioned modal window on top of every other element in the app.
   * @param {string} htmlContent
   * @param {object} position
   */
  show(htmlContent: JQLite, position, objectHeight: number, hideBackdrop?: boolean) {
    this.$rootScope.hideBackdrop = hideBackdrop || false;

    const containerElem = document.querySelector('.modal-overlay-content');
    const contentElem = angular.element(document.querySelector('.modal-overlay-content-inner'));

    contentElem.html('');
    contentElem.append(htmlContent);

    // Prevent modal from being off screen when to far at th bottom of the page

    if (position.top + objectHeight > window.innerHeight) {
      containerElem.style.bottom = 0;
      containerElem.style.top = 'auto';
    } else {
      containerElem.style.top = `${position.top + position.height}px`;
      containerElem.style.bottom = 'auto';
    }

    containerElem.style.left = `${position.left}px`;

    this.$rootScope.showModalOverlay = true;
  }

  hide() {
    this.$rootScope.modalOverlayContent = '';
    this.$rootScope.showModalOverlay = false;
  }
}

export default angular.module('services.modalOverlayService', [])
  .service('modalOverlayService', ModalOverlayService)
  .name;
